import calendarHeaderDayUrl from './calendarHeaderDay.html';
export default {
  templateUrl: calendarHeaderDayUrl,
  controllerAs: 'ctrl',
  bindings: {
    hours: '<',
    properHours: '<',
    currentHour: '<',
    isTodaySelected: '<',
  },
};
